// extracted by mini-css-extract-plugin
export var measureBox = "_ak-0";